<template>
	<v-hover v-slot="{ hover }">
		<v-card
			:elevation="hover ? 2 : 0"
			outlined
			:shaped="shaped"
			class="pb-0 pt-0 text-center"
			:to="{ name: 'replacement' , params: { recordID: record.replacementID}}"
		>
			<v-card-text style="word-break: normal;" class="pb-0">
				<div class="text-body-1">{{ record.replacementID }}) {{ record.title }}</div>
			</v-card-text>
			<v-card-text>
				<v-chip v-if="record.publishedWrite" class="ma-1 mb-0" color="primary" dark>
					{{ record.publishedWrite }}
					<v-icon right>mdi-calendar</v-icon>
				</v-chip>
				<v-chip class="ma-1 mb-0" color="primary" dark>
					{{ record.gender }}
					<v-icon right>{{ record.genderIcon }}</v-icon>
				</v-chip>
				<template v-if="record.toRegion == record.fromRegion">
					<v-chip class="ma-1 mb-0" color="primary" dark>
						{{ record.fromRegion }}
						<v-icon right>mdi-map-marker-radius</v-icon>
					</v-chip>
				</template>
				<template v-else>
					<v-chip class="ma-1 mb-0" color="primary" dark>
						من
						{{ record.fromRegion }}
						<v-icon right>mdi-map-marker-left</v-icon>
					</v-chip>
					<v-chip v-if="record.toRegion" class="ma-1 mb-0" color="primary" dark>
						إلى
						{{ record.toRegion }}
						<v-icon right>mdi-map-marker-right</v-icon>
					</v-chip>
				</template>
			</v-card-text>
		</v-card>
	</v-hover>
</template>

<script>
export default {
	props: {
		record: {
			type: Object,
			required: true
		},
		shaped: {
			type: Boolean,
			default: false
		}
	},
	// computed: {
	// 	configViewCount() {
	// 		return this.$store.state.viewCount;
	// 	}
	// },
}
</script>
